export default __webpack_public_path__ + "static/media/July2017.f4e34f3c.png";